import { FormattedMessage } from 'react-intl'
import { isValidEmail } from '../../utils'
import get from 'lodash/get'
import set from 'lodash/set'
import isEmpty from 'lodash/isEmpty'

const travelersRequired = [
  'genderTitle',
  'firstName',
  'lastName',
  'dob',
  'certificationLevel',
  'certifyingAgency',
  'numberOfDives',
  'lastDiveDate',
]
const courseRequired = [
  'genderTitle',
  'firstName',
  'lastName',
  'dob',
  'certificationLevel',
]

const nonExperienced = ['genderTitle', 'firstName', 'lastName', 'dob']

const requiredByKind = {
  10: travelersRequired,
  20: travelersRequired,
  30: courseRequired,
  40: nonExperienced,
  50: nonExperienced,
}
const requiredText = (
  <FormattedMessage
    id='required_field'
    defaultMessage='This field is required!'
  />
)

export default function adventureCheckoutValidate(
  values,
  phoneInstance,
  isElearning,
) {
  const requiredFields = values.isNonExperienced
    ? nonExperienced
    : requiredByKind[values.productType]
  const errors = {}
  if(!values.firstName) {
    errors.firstName = requiredText
  }
  if(!values.lastName) {
    errors.lastName = requiredText
  }
  if(!values.email) {
    errors.email = requiredText
  } else if(values.email && !isValidEmail(values.email)) {
    errors.email = (
      <FormattedMessage id='invalid_email' defaultMessage='Invalid email' />
    )
  }
  if(!values.phone) {
    errors.phone = requiredText
  } else if(phoneInstance?.isValidNumber() === false) {
    errors.phone = (
      <FormattedMessage
        id='error_phone'
        defaultMessage='Invalid Phone number'
      />
    )
  }
  if(!values.isTermsAccepted) {
    errors.isTermsAccepted = true
  }
  if(!values.isTermsAcceptedDc) {
    errors.isTermsAcceptedDc = true
  }
  if(values.includedTransfer) {
    const point = get(
      values,
      'trips[0].additionalRequirements.userPickupPoint.pickupPointId',
    )
    const address = get(
      values,
      'trips[0].additionalRequirements.userPickupPoint.address',
    )
    if(values.pickupPoints && !point) {
      set(
        errors,
        'trips[0].additionalRequirements.userPickupPoint.pickupPointId',
        requiredText,
      )
    } else if(!values.pickupPoints && !address) {
      set(
        errors,
        'trips[0].additionalRequirements.userPickupPoint.address',
        requiredText,
      )
    }
  }
  values?.trips?.[0]?.travelers?.forEach((traveler, index) => {
    const travelerErrors = {}
    requiredFields.forEach((field) => {
      if(!traveler[field]) {
        if(isElearning && !traveler?.email) {
          set(errors, `trips[0].travelers[${index}]['email']`, requiredText)
        }
        set(errors, `trips[0].travelers[${index}][${field}]`, requiredText)
      }
    })
    if(!isEmpty(travelerErrors)) {
      errors.trips[0].travelers.push(travelerErrors)
    }
  })

  return errors
}
